import React, { useEffect, useState } from "react";
import {
  IBannerData,
  IMemberListData,
  INewsLetterData,
} from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { useLoader } from "../context/LoaderContext";
import {
  fetchNewsLetterBanner,
  fetchNewsLetterData,
} from "../api/NewsLetterApi";
import NewsLetterBanner from "../components/newsLetter/NewsLetterBanner";
import AllNewsLetter from "../components/newsLetter/AllNewsLetter";
import { useUserDataContext } from "../context/UserDataContext";
import { fetchMemberLists } from "../api/MemberApi";

const NewsLetter = () => {
  const { setLoading } = useLoader();
  const { userData } = useUserDataContext();
  const [newsLetterData, setNewsLetterData] = useState<INewsLetterData[]>([]);
  const [newsLetterBannerData, setNewsLetterBannerData] = useState<
    IBannerData[]
  >([]);
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const [matchedMember, setMatchedMember] = useState<
    IMemberListData | undefined
  >(undefined); 

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchNewsLetterBanner(),
      fetchNewsLetterData(),
      fetchMemberLists(),
    ])
      .then(([newsLetterBannerData, newsLetterData, listMemberData]) => {
        setNewsLetterBannerData(newsLetterBannerData);
        setNewsLetterData(newsLetterData);
        setListMemberData(listMemberData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  useEffect(() => {
    if (userData?.data?.id && listMemberData.length > 0) {
      const match = listMemberData.find(
        (member) => member?.attributes?.sis_id === String(userData?.data?.id)
      );
      setMatchedMember(match || undefined);
    }
  }, [userData, listMemberData]);
  return (
    <>
      <NewsLetterBanner newsLetterBannerData={newsLetterBannerData} />
      <AllNewsLetter
        newsLetterData={newsLetterData}
        matchedMember={matchedMember}
      />
    </>
  );
};

export default NewsLetter;
